const actions = {
    GET_CLIENT_DATA : 'GET_CLIENT_DATA',
    GET_CLIENT_DATA_SUCCESS : 'GET_CLIENT_DATA_SUCCESS',
    GET_CLIENT_DATA_FAILED : 'GET_CLIENT_DATA_FAILED',

    getClientData:()=>({
        type: actions.GET_CLIENT_DATA,
        payload: {},
    }),
    getClientDataSuccess:(totalData)=>({
        type: actions.GET_CLIENT_DATA_SUCCESS,
        payload:{totalData}
    }),
    getClientDataFailed:(error)=>({
        type: actions.GET_CLIENT_DATA_FAILED,
        payload: { error },
    })
}
export default actions